

import { ReactNode } from "react";

interface SectionCardProps {
  title: string;
  icon: ReactNode;
  children: ReactNode;
  className?: string;
}

export function SectionCard({ title, icon, children, className = "" }: SectionCardProps) {
  return (
    <div className={`bg-white rounded-2xl border border-stone-200 ${className}`}>
      <div className="flex items-center gap-2 px-4 sm:px-5 py-3 sm:py-4 border-b border-stone-100">
        <span className="text-stone-500 flex-shrink-0">{icon}</span>
        <h3 className="font-bold text-stone-800 font-serif text-sm truncate">{title}</h3>
      </div>
      <div className="p-4 sm:p-5">{children}</div>
    </div>
  );
}
